export const SET_ORIGINAL_STATE = 'settings/setOriginalState';

export const SET_EMAIL_PREFERENCES = 'settings/setEmailPreferences';

export const SET_IN_PROGRESS = 'settings/saveSettingsInProgress';
export const SAVE_SETTINGS = 'settings/saveSettings';
